<script setup lang="ts">

interface Props {
  href?: string
  as?: 'a' | 'span'
  icon?: `i-${string}:${string}`
  size?: 'sm' | 'base' | undefined
}

withDefaults(defineProps<Props>(), {
  as: 'a',
  icon: 'i-uil:arrow-up-right',
  size: 'base'
})

</script>

<template>
  <component 
    :is="as" 
    :href="href ? href : ''" 
    class="inline-flex items-center group/link"
    :class="[size === 'sm' && 'text-sm']"
  >
    <span class="font-medium duration-300 ease-in-out group-hover/link:underline group-focus/link:underline">
      <slot />
    </span>
    <span 
      :class="[
        'duration-300 ease-in-out group-hover/link:(scale-90 opacity-100) group-focus/link:(scale-90 opacity-100) origin-tr opacity-40 mt-.5 ml-1 shrink-0 inline-block',
        size === 'base'
          ? 'text-xl'
          : 'text-lg',
        icon
      ]" 
    />
  </component>
</template>